export const specificCategoriesSection: Readonly<Record<string, Array<string>>> = {
	'ARO-NA': [
		'aro-manually-operated-pneumatic-valves',
		'aro-solenoid-operated-pneumatic-valves',
		'aro-pilot-operated-pneumatic-valves',
	],
	DT: ['dt-water-powered-injectors', 'dt-mobile-dosing-carts'],
};
